import SiteHeader from '../shared/SiteHeader.jsx'
import { SiteFooter } from '../shared/SiteFooter.jsx'

// The signed-in pages' frame: the site's one header and one footer around the
// page. Both moved to `shared/` on 2026-10-30, when the public pages and the
// app started sharing them; the reasoning for the header — sign out, the trial
// line, the logo, "Dashboard" — moved with it. See `shared/SiteHeader.jsx`.
//
// `beforeBusiness` is the setup page for an account's first business, where
// Dashboard and Questions would loop back to the page already open.
export default function SignedInLayout({ children, beforeBusiness = false }) {
  return (
    <div className="min-h-screen bg-[color:var(--bg-base)]">
      <SiteHeader beforeBusiness={beforeBusiness} />
      {children}
      <SiteFooter />
    </div>
  )
}

// The idiom the integrated pages already use, and the export dropped it — only
// the two Billing pages attached a layout, so Overview, Questions, Account and
// brand settings would each have rendered with no header and no way out of them.
export const withSignedInLayout = (page) => <SignedInLayout>{page}</SignedInLayout>
